import { FC, ReactNode } from 'react';
import { INotificationComponentOuter } from '../../../components/notifications/notifications.types';

export interface INotification {
  id: string;
  NotificationComponent: FC<INotificationComponentOuter>;
  dismiss: () => void;
}

export interface INotificatorContext {
  notifications: INotification[];
  notify: (message: ReactNode) => void;
}

export enum NotificationStateActionType {
  Add,
  Remove,
}

export interface INotificationAction {
  type: NotificationStateActionType;
  payload: Partial<{
    id: string;
    notification: INotification;
  }>;
}
